import React from "react";
import PropTypes from "prop-types";
import { Loader } from "@src/components/atoms";
import {
  CardContainer,
  HorizontalResponsiveLayout,
} from "@src/components/cards";
import AccountExamplesCard from "@src/components/cards/manager/AccountExamplesCard";
import ActivityPageViewsCard from "@src/components/cards/manager/ActivityPageViewsCard";
import AppUtils from "@src/utils/appUtils";

/** Previously called AccountsCard */
const OnlineAccountSection = (props) => {
  const {
    industry,
    isLoading = false,
    exampleTitle,
    exampleExpand,
    exampleDropdownOnChange,
    exampleScreenOptions,
    exampleScreenImage,
    pageViewsTitle,
    pageViews,
  } = props;

  return (
    <HorizontalResponsiveLayout
      horizontal={{ ratio: [3, 2] }}
      vertical={{ reverse: true }}
      gap={2}
      breakpoint="tablet"
    >
      <CardContainer
        padding={false}
        className="shadow-md lg:mr-3 mb-6 lg:mb-0"
        shadow={false}
      >
        {isLoading ? (
          <div className="p-5">
            <Loader size="lg" />
          </div>
        ) : (
          <AccountExamplesCard
            industry={industry}
            title={exampleTitle}
            expand={exampleExpand}
            exampleDropdownOnChange={exampleDropdownOnChange}
            exampleScreenOptions={exampleScreenOptions}
            exampleScreenImage={exampleScreenImage}
          />
        )}
      </CardContainer>
      <CardContainer
        padding={false}
        className="shadow-md lg:ml-3"
        shadow={false}
      >
        {isLoading || !pageViews ? (
          <div className="p-5">
            <Loader size="lg" />
          </div>
        ) : (
          <ActivityPageViewsCard title={pageViewsTitle} pageViews={pageViews} />
        )}
      </CardContainer>
    </HorizontalResponsiveLayout>
  );
};
// export const onlineAccountSectionControls = {};
// OnlineAccountSection.propTypes = AppUtils.getPropTypeFromControls(
//   onlineAccountSectionControls
// );

export default OnlineAccountSection;
